export const CMSContentStyles = {
  CMSContentWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "1.2rem",
    paddingX: 3.5,
    paddingY: 2,
  },
  CMSContentCard: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "1px solid rgba(175, 175, 175, 1)",
    borderRadius: "10px",
    width: " 447px",
    left: "30px",
    //flex: "1 1 calc(25% - 0.9rem)",
  },
  CMSContentCardContent: {
    height: "180px",
    display: "grid",
    gridTemplateRows: "1fr 0.5fr",
    gap: "20px",
    padding: "24px",
  },
  CMSContentHeading: {
    fontFamily: "Noto Sans",
    fontSize: " 18px",
    fontColor: "rgba(29, 37, 43, 1)",
    fontWeight: "400",
    "@media (max-width: 699px)": {
      fontSize: "14px",
    },
    maxHeight: "50px",
    overflow: "hidden",
  },
  QuickReferencesHeading: {
    fontFamily: "Playfair Display",
    fontSize: "20px",
    fontWeight: "500",
    paddingX: 3.5,
  },
};
